import styled from 'styled-components';
import { media } from '../../config/helpers/queries/media';

export const ButtonWrapperStyles = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 66px;
  font-size: 14px;
  margin-bottom: 64px;
  
  ${media.desktop`
    justify-content: end;
    margin-bottom: 0px;
 `}
`;
